const ROLES = {
  ADMIN: { writer: true, reader: true, setting: true },
  CONTROL_FACILITY: { writer: true, reader: true, setting: false },
  CONTROL: { writer: false, reader: true, setting: false },
  REQUEST_USER: { writer: true, reader: true, setting: false },
  DEFAULT: { writer: false, reader: true, setting: false },
};

export default {
  state: {
    info: {},
    //users: null,
    user: null,
    userRoles: null,
    modules: null,
    visibleColumns: {}
  },
  actions: {
    async fetchInfo({ commit }, formData) {
      commit('SET_INFO', formData);
    },
    setPasswordIsOld({ commit }, passwordIsOld) {
      commit('SET_PASSWORD_IS_OLD', passwordIsOld);
    },
    setUserRoles({ commit }, val) {
      commit('SET_USER_ROLE', val);
    },
    setUser({ commit }, val) {
      commit('SET_USER', val);
    },
    setVisibleColumns: ({ commit, state }, { table, columns }) => {
      if (!state.info?.login || !table || !columns) return;
      const visibleColumns = state.visibleColumns ? state.visibleColumns : {};

      visibleColumns[state.info.login] = visibleColumns[state.info.login] || {};
      visibleColumns[state.info.login][table] = columns;
      commit('SET_VISIBLE_COLUMNS', visibleColumns);
    },
  },
  mutations: {
    SET_INFO(state, info) {
      state.info = info;
    },
    SET_MODULES(state, modules) {
      state.modules = modules;
    },
    SET_USER_ROLE(state, userRoles) {
      state.userRoles = userRoles;
      const ADMIN_ID = 1,
        CONTROL_ID = 3
      const indexA = state.userRoles.findIndex(item => item.role_id === ADMIN_ID);
      if (indexA > -1) {
        state.info.isAdmin = state.userRoles[indexA].cbox == 1;
      } else {
        state.info.isAdmin = false;
      }
      const indexC = state.userRoles.findIndex(item => item.role_id === CONTROL_ID);
      if (indexC > -1) {
        state.info.isControl = state.userRoles[indexC].cbox == 1 || (indexA > -1 && state.userRoles[indexA].cbox == 1);
      } else {
        state.info.isControl = false;
      }
    },
    CLEAR_INFO(state) {
      state.info = {};
      localStorage.removeItem("token");
      localStorage.removeItem("password");
      sessionStorage.removeItem("sessionStorage");
      localStorage.removeItem('vuex-multi-tab');
    },
    SET_USER(state, user) { // заполняем инфо о текущем пользователей   
      state.user = user[0];
      if (state.info.passwordExpirationDate) { // перенести логику в роутер?!
        const diffMs = new Date() - new Date(state.info.passwordExpirationDate);
        const passwordIsOld = diffMs > 3 * 60 * 60 * 1000;
        state.info.passwordIsOld = passwordIsOld;
      }
      state.info.userId = state.user.user_id;
      state.info.userRoleName = state.user.user_role_name;
    },
    SET_PASSWORD_IS_OLD(state, passwordIsOld) {
      state.info.passwordIsOld = passwordIsOld;
    },
    SET_VISIBLE_COLUMNS(state, visibleColumns) {
      state.visibleColumns = visibleColumns;
    },
  },
  getters: {
    info: s => s.info,
    user: s => s.user,
    password: (s, g) => g.decrypted(s.info.password),
    userRoles: s => s.userRoles,
    modules: s => s.modules,
    roleTask: (s) => (task) => {
      if (s.info.isAdmin) {
        return ROLES.ADMIN;
      }
      if (task === 'facility') {
        return s.info.isControl ? ROLES.CONTROL_FACILITY : ROLES.CONTROL;
      }
      if (task === 'request-user') {
        return ROLES.REQUEST_USER;
      }
      return ROLES.DEFAULT;
    },
    visibleColumns: s => s.visibleColumns?.[s.info?.login]
  }
};